import { carregarUsuarioDaStore } from '@/integracoes/src-next/catalogos/catalogos-governanca.vuex'
import { freezeItems } from './freezeItems'

const defaultOnly = [
  'id', 'name', 'email', 'role_group'
]
const PER_PAGE = 30

function normalizeUsers (items) {
  return Array.isArray(items) ? items.filter(item => item && typeof item === 'object') : []
}

export default {
  namespaced: true,
  state: {
    page: 0,
    items: [],
    loading: false,
    deleted: false,
    totalPages: 0,
    pronto: false,
    atualizando: false,
    erro: null,
    sincronizadoEm: null
  },
  getters: {
    usuariosQueSaoEmpregados (state) {
      return state.items.filter(usuario => usuario?.roleGroup?.kind === 'mine')
    },
    usuariosQueSaoGestores (state) {
      return state.items.filter(usuario => usuario?.roleGroup?.kind === 'group')
    },
    usuariosQueTemFuncionario (state) {
      return state.items.filter(i => i?.compemployee?.id)
    },
    usuariosGestoresERh (state) {
      return state.items.filter(usuario => ['group', 'all'].includes(usuario?.roleGroup?.kind))
    },
    usuariosSomenteRh (state) {
      return state.items.filter(usuario => usuario?.roleGroup?.kind === 'all')
    },
    todosUsuarios (state) {
      return state.items
    },
    aindaFaltaMostrarPaginas (state) {
      const {page, totalPages, items} = state
      const saoNumeros = [page, totalPages].every(v => typeof v === 'number')
      const possuiMenosQuePerPage = items.length < PER_PAGE
      const maisPaginasAlemDaAtual = totalPages > page
      return saoNumeros && !possuiMenosQuePerPage && maisPaginasAlemDaAtual
    }
  },
  mutations: {
    saveItems (state, payload) {
      state.items = freezeItems(normalizeUsers(payload))
      state.page = 0
      state.loading = false
    },
    appendItems (state, payload) {
      state.items = freezeItems([...new Map([...state.items, ...normalizeUsers(payload)].map(item => [item.id, item])).values()])
      state.loading = false
    },
    setDeleted (state, payload) {
      state.deleted = payload
    },
    resetItems (state) {
      state.items = []
      state.pronto = false
      state.loading = false
      state.atualizando = false
      state.erro = null
      state.sincronizadoEm = null
    },
    publicarCatalogo (state, { items, ...estado }) {
      if (items !== undefined) state.items = freezeItems(items)
      Object.assign(state, estado)
    },
    loading (state, payload) {
      state.loading = Boolean(payload)
    },
    setTotalPages (state, payload) {
      state.totalPages = payload
    },
    setPage (state, payload) {
      state.page = payload
    }
  },
  actions: {
    async fetchItems ({ state, dispatch }, payload = {}) {
      const campos = payload.withFields || []
      if (payload.deleted === true || payload.deleted === 'true' || payload.page !== undefined || payload.search || payload.perfil || campos.some(campo => !['id', 'name', 'email', 'role_group', 'compemployee'].includes(campo))) return dispatch('consultarItensEspecificos', payload)
      await carregarUsuarioDaStore(this, payload.fullReload === true)
      return state.items
    },
    async consultarItensEspecificos (contexto, payload = {}) {
      const { API, retryRequest } = await import('src/services')
      const result = await retryRequest(payload.perfil ? API.userPerfil.get : API.user.get, {
        fields: JSON.stringify([...new Set([...defaultOnly, ...(payload.withFields || [])])]),
        order_by: 'name', deleted: payload.deleted,
        ...(payload.perfil ? { perfil: payload.perfil } : {}),
        ...(payload.search ? { search: payload.search } : {}),
        ...(payload.page !== undefined ? { page: payload.page, per_page: payload.per_page || PER_PAGE } : {})
      })
      return result.status === 204 ? { success: [], total: 0, totalPages: 0 } : result.body
    },
    async fetchItemsComPaginacao ({ dispatch }, payload = {}) {
      return dispatch('consultarItensEspecificos', { ...payload, page: payload.page || 0, per_page: PER_PAGE })
    }
  }
}
